import { takeLatest, ForkEffect } from 'redux-saga/effects';
import ActionConstants from '../constants/';
import workerSaga from './workerSaga';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* completeProfileWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLatest(ActionConstants.GET_MERCHANT_PROFILE_ACTION, workerSaga);
  yield takeLatest(ActionConstants.UPDATE_MERCHANT_PROFILE_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_IFSC_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_SIGNZY_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_PANTOGSTLIST_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_PAN_VERIFY_ACTION, workerSaga);
  yield takeLatest(ActionConstants.VERIFY_KYC_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_STATE_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_CITY_ACTION, workerSaga);
  yield takeLatest(ActionConstants.KYC_FORM_SUBMIT_ACTION, workerSaga);
  yield takeLatest(ActionConstants.KYC_FORM_RESUBMIT_ACTION, workerSaga);
  yield takeLatest(ActionConstants.GET_BANK_VERIFY_ACTION, workerSaga);
  yield takeLatest(ActionConstants.UPDATE_ACCOUNT_ACTION, workerSaga);
  yield takeLatest(ActionConstants.TOGGLE_ENV_ACTION, workerSaga);
}
